import "./Header.scss"
import logo from '../../img/logo.svg';

const Header = () => {
    return(
        <header className="header">
            <nav className="header-nav">
                <div className="header-nav-left">
                    <a className="header-nav-a" href="/#team">team</a>
                    <a className="header-nav-a" href="/about" >about </a>
                </div>

                <a href="/">
                 <img className="header-nav-logo" alt="INDOMITUS LOGOTYPE" src={logo}></img>
                </a>
                <div className="header-nav-right">
                    <a className="header-nav-a" href="/#partners">partners</a>
                    <a className="header-nav-a" href="/#contact-us">contact us</a>
                </div>
            </nav>
            <div className="header-phone">

            </div>
        </header>
    );
}
export default Header;